"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIrsStandardForHealthCareExpenses = exports.getIrsStandardForTotalExpenses = exports.getIrsStandardForExpenses = void 0; //https://www.irs.gov/pub/irs-utl/national-standards.pdf
//NOTE: the student loan forms are currently using the 2022 standards (so they're out of date)

var getIrsStandardForExpenses = function getIrsStandardForExpenses(householdSize, irsCategory) {
  var categoryToStandards = {
    food: {
      1: 466,
      2: 777,
      3: 936,
      4: 1123
    },
    housekeeping: {
      1: 47,
      2: 80,
      3: 85,
      4: 90
    },
    apparel: {
      1: 96,
      2: 145,
      3: 207,
      4: 252
    },
    personal_care: {
      1: 43,
      2: 78,
      3: 91,
      4: 97
    },
    misc: {
      1: 189,
      2: 309,
      3: 381,
      4: 431
    }
  };
  var standards = categoryToStandards[irsCategory];
  return standards[Math.min(householdSize, 4)];
};

exports.getIrsStandardForExpenses = getIrsStandardForExpenses;

var getIrsStandardForTotalExpenses = function getIrsStandardForTotalExpenses(householdSize) {
  var additionalAllowancePerHouseholdMember = 356;
  var totalStandards = {
    1: 841,
    2: 1389,
    3: 1700,
    4: 1993
  };
  return totalStandards[Math.min(householdSize, 4)] + additionalAllowancePerHouseholdMember * Math.max(householdSize - 4, 0);
};

exports.getIrsStandardForTotalExpenses = getIrsStandardForTotalExpenses; //IMPORTANT NOTE: IRS health care standards are separate from the rest
//(they're not included in the IRS Expense Standard Totals)
//I don't make the rules
//https://www.irs.gov/businesses/small-businesses-self-employed/national-standards-out-of-pocket-health-care
//TODO: this is wrong. We need to compare each household member's expenses to an individual member's age

var getIrsStandardForHealthCareExpenses = function getIrsStandardForHealthCareExpenses(householdMembers) {
  var ageLimit = 65;
  var standardOverOrEqualToAgeLimit = 154;
  var standardUnderAgeLimit = 79;
  return householdMembers.reduce(function (accumulator, householdMember) {
    return accumulator + (householdMember.age >= ageLimit ? standardOverOrEqualToAgeLimit : standardUnderAgeLimit);
  }, 0);
};

exports.getIrsStandardForHealthCareExpenses = getIrsStandardForHealthCareExpenses;